import React from 'react'
import "./style.css"

export default function CreateTaskModal({ handleSave, text }) {
  if (text) {
    document.getElementById('notetext').value = text
  }
  return (
    <div class="modal fade create-task-modal" id='createNote'>
      <div class="modal-dialog kw_md">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">Create Note</div>
            <span class="icon-Group-240" data-dismiss="modal">  </span>
          </div>

          <div class="modal-body">
            <textarea id='notetext' placeholder="Start typing..." ></textarea>
          </div>

          <div class="mfooter">
            <input
              type="submit"
              className="mSmall to-right lg_btn primary m-2"
              value="save"
              id="save"
              data-dismiss="modal"
              onClick={(e) => handleSave(document.getElementById('notetext').value)}
            />
            <a to="" style={{ cursor: 'pointer' }} class="mSmall to-left lg_btn tertiary m-2" data-dismiss="modal">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div >
  )
}
